import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import * as signalR from '@microsoft/signalr';
import { SimpleNotificationViewModel } from '@view-models/notifications/simple-notification';
import { AuthResponse, ServerHashParamKeys } from 'msal';
import * as proxy from 'proxy.config.json';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

let targetUrl = '/';
if (environment.production !== true) {
  targetUrl = proxy['/api'].target;
}
@Injectable({
  providedIn: 'root',
})
export class NotificationDispatcherService implements OnInit, OnDestroy {
  private notificationsSubject$ = new Subject<SimpleNotificationViewModel>();
  notifications$ = this.notificationsSubject$.asObservable();
  connection: signalR.HubConnection;
  constructor(private msalService: MsalService, private http: HttpClient) {}

  ngOnInit() {
    this.getToken().then((t) => {
      this.connection = new signalR.HubConnectionBuilder()
        .configureLogging(signalR.LogLevel.Warning)
        .withUrl(`${targetUrl}api/CleanFillHub`, { accessTokenFactory: () => t })
        .build();

      this.connection.on('GeneralNotificationEvent', (update: SimpleNotificationViewModel) => {
        console.log('notification', update);
        this.notificationsSubject$.next(update);
      });
      this.connection.start().catch((err) => console.error(err.toString()));
    });
  }
  ngOnDestroy() {
    this.connection.stop();
  }
  async getToken() {
    const scopes = this.msalService.getScopesForEndpoint('/');
    const response: AuthResponse = await this.msalService.acquireTokenSilent({ scopes });
    const token = response.tokenType === ServerHashParamKeys.ID_TOKEN ? response.idToken.rawIdToken : response.accessToken;
    return token;
  }
}
